// Shared utility functions for create-claim component

export const $getCategorySelect = () => document.getElementById("js-category-select");
export const $getSubcategorySelect = () => document.getElementById("js-subcategory-select");

export const isShipmentMissingScenario = () => {
  const $categorySelect = $getCategorySelect();
  const $subcategorySelect = $getSubcategorySelect();
  return (
    $categorySelect?.value === "made_blanks_issue" &&
    $subcategorySelect?.value === "shipment_missing"
  );
};
